"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clsx = clsx;
exports.showSearch = showSearch;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyleData = {
  Global: {
    prefix: 'Mui-',
    rules: {
      "disabled": {},
      "focusVisible": {}
    }
  },
  Icon: {
    prefix: 'MuiIcon-',
    rules: {
      "root": {
        "width": "1em",
        "height": "1em",
        "overflow": "hidden",
        "font-size": "1.7142857142857144em",
        "flex-shrink": "0",
        "user-select": "none"
      },
      "colorPrimary": {
        "color": "#003369"
      },
      "colorSecondary": {
        "color": "#2ca549"
      },
      "colorAction": {
        "color": "rgba(0, 0, 0, 0.54)"
      },
      "colorError": {
        "color": "#f44336"
      },
      "colorDisabled": {
        "color": "rgba(0, 0, 0, 0.26)"
      },
      "fontSizeInherit": {
        "font-size": "inherit"
      },
      "fontSizeSmall": {
        "font-size": "1.4285714285714288em"
      },
      "fontSizeLarge": {
        "font-size": "2.5714285714285716em"
      }
    }
  },
  ButtonBase: {
    prefix: 'MuiButtonBase-',
    rules: {
      "root": {
        "color": "inherit",
        "border": "0",
        "cursor": "pointer",
        "margin": "0",
        "display": "inline-flex",
        "outline": "0",
        "padding": "0",
        "position": "relative",
        "align-items": "center",
        "user-select": "none",
        "border-radius": "0",
        "vertical-align": "middle",
        "-moz-appearance": "none",
        "justify-content": "center",
        "text-decoration": "none",
        "background-color": "transparent",
        "-webkit-appearance": "none",
        "-webkit-tap-highlight-color": "transparent",
        '&::moz-focus-inner': {
          "border-style": "none"
        },
        '&.Mui-disabled': {
          "cursor": "default",
          "pointer-events": "none"
        },
        '@media print': {
          "-webkit-print-color-adjust": "exact"
        }
      }
    }
  },
  Button: {
    prefix: "MuiButton-",
    rules: {
      "root": {
        "color": "rgba(51, 51, 51, 87%)",
        "padding": "6px 16px",
        "font-size": "1em",
        "min-width": "64px",
        "box-sizing": "border-box",
        "transition": "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        "font-weight": "400",
        "line-height": "1.5",
        "border-radius": "4px",
        "text-transform": "uppercase",
        '&:hover': {
          "text-decoration": "none",
          "background-color": "rgba(51, 51, 51, 0.04)",
          '@media (hover: none)': {
            "background-color": "transparent"
          }
        },
        '&.Mui-disabled': {
          "color": "rgba(0, 0, 0, 0.26)",
          '&:hover': {
            "background-color": "transparent"
          }
        }
      },
      "label": {
        "width": "100%",
        "display": "inherit",
        "align-items": "inherit",
        "justify-content": "inherit"
      },
      "text": {
        "padding": "6px 8px"
      },
      "textPrimary": {
        "color": "#003369",
        '&:hover': {
          "background-color": "rgba(0, 51, 105, 0.04)",
          "@media (hover: none)": {
            "background-color": "transparent"
          }
        }
      },
      "textSecondary": {
        "color": "#2ca549",
        "&:hover": {
          "background-color": "rgba(44, 165, 73, 0.04)",
          "@media (hover: none)": {
            "background-color": "transparent"
          }
        }
      },
      "outlined": {
        "border": "1px solid rgba(0, 0, 0, 0.23)",
        "padding": "5px 15px",
        "&.Mui-disabled": {
          "border": "1px solid rgba(0, 0, 0, 0.12)"
        }
      },
      "outlinedPrimary": {
        "color": "#003369",
        "border": "1px solid rgba(0, 51, 105, 0.5)",
        "&:hover": {
          "border": "1px solid #003369",
          "background-color": "rgba(0, 51, 105, 0.04)",
          "@media (hover: none)": {
            "background-color": "transparent"
          }
        }
      },
      "outlinedSecondary": {
        "color": "#2ca549",
        "border": "1px solid rgba(44, 165, 73, 0.5)",
        "&:hover": {
          "border": "1px solid #2ca549",
          "background-color": "rgba(44, 165, 73, 0.04)",
          "@media (hover: none)": {
            "background-color": "transparent"
          }
        },
        "&.Mui-disabled": {
          "border": "1px solid rgba(0, 0, 0, 0.26)"
        }
      },
      "contained": {
        "color": "rgba(0, 0, 0, 0.87)",
        "box-shadow": "0px 1px 1px 0px #ccc",
        "background-color": "#e0e0e0",
        "&:hover": {
          "box-shadow": "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
          "background-color": "#d5d5d5",
          "@media (hover: none)": {
            "box-shadow": "0px 1px 1px 0px #ccc",
            "background-color": "#e0e0e0"
          },
          "&.Mui-disabled": {
            "background-color": "rgba(0, 0, 0, 0.12)"
          }
        },
        "&.Mui-focusVisible": {
          "box-shadow": "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)"
        },
        "&:active": {
          "box-shadow": "0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)"
        },
        "&.Mui-disabled": {
          "color": "rgba(0, 0, 0, 0.26)",
          "box-shadow": "none",
          "background-color": "rgba(0, 0, 0, 0.12)"
        }
      },
      "containedPrimary": {
        "color": "#fff",
        "background-color": "#003369",
        "&:hover": {
          "background-color": "rgb(0, 35, 73)",
          "@media (hover: none)": {
            "background-color": "#003369"
          }
        }
      },
      "containedSecondary": {
        "color": "#fff",
        "background-color": "#2ca549",
        "&:hover": {
          "background-color": "rgb(30, 115, 51)",
          "@media (hover: none)": {
            "background-color": "#2ca549"
          }
        }
      },
      "disableElevation": {
        "box-shadow": "none",
        "&:hover": {
          "box-shadow": "none"
        },
        "&.Mui-focusVisible": {
          "box-shadow": "none"
        },
        "&:active": {
          "box-shadow": "none"
        },
        "&.Mui-disabled": {
          "box-shadow": "none"
        }
      },
      "colorInherit": {
        "color": "inherit",
        "border-color": "currentColor"
      },
      "textSizeSmall": {
        "padding": "4px 5px",
        "font-size": "0.9285714285714286em"
      },
      "textSizeLarge": {
        "padding": "8px 11px",
        "font-size": "1.0714285714285716em"
      },
      "outlinedSizeSmall": {
        "padding": "3px 9px",
        "font-size": "0.9285714285714286em"
      },
      "outlinedSizeLarge": {
        "padding": "7px 21px",
        "font-size": "1.0714285714285716em"
      },
      "containedSizeSmall": {
        "padding": "4px 10px",
        "font-size": "0.9285714285714286em"
      },
      "containedSizeLarge": {
        "padding": "8px 22px",
        "font-size": "1.0714285714285716em"
      },
      "fullWidth": {
        "width": "100%"
      },
      "iconSizeSmall": {
        "& > *:first-child": {
          "font-size": "18px"
        }
      },
      "iconSizeMedium": {
        "& > *:first-child": {
          "font-size": "20px"
        }
      },
      "iconSizeLarge": {
        "& > *:first-child": {
          "font-size": "22px"
        }
      },
      "startIcon": {
        "display": "inherit",
        "margin-left": "-4px",
        "margin-right": "8px",
        "&$iconSizeSmall": {
          "margin-left": "-2px"
        }
      },
      "endIcon": {
        "display": "inherit",
        "margin-left": "8px",
        "margin-right": "-4px",
        "&$iconSizeSmall": {
          "margin-right": "-2px"
        }
      }
    }
  },
  SearchModal: {
    prefix: 'SearchModal-',
    rules: {
      modalWrapper: {},
      modalWrapperIn: {},
      button: {
        color: '#616161',
        "width": "2em",
        "border": "1px solid #616161",
        "height": "2em",
        "padding": "0",
        "font-size": "1em",
        "min-width": "0",
        "margin-left": ".5em",
        "margin-right": "1em",
        "border-radius": "1em",
        "background-color": "transparent",
        "&:hover": {
          "background-color": "#eeeeee"
        }
      },
      "buttonLabel": {
        "padding": "0",
        "min-width": "0"
      },
      "buttonIcon": {
        "font-size": "1em"
      },
      "modalRoot": {
        "top": "0",
        "left": "0",
        "width": "100vw",
        "height": "100vh",
        "opacity": "0",
        "z-index": "1300",
        "overflow": "auto",
        "position": "fixed",
        "transform": "translateY(-100%)",
        "background": "rgba(255, 255, 255, 1)",
        "transition": "opacity .2s ease-in-out, transform .2s ease-in-out",
        '--default-list-image': 'url(/channels/marketing/images/Search-default-image.png)'
      },
      "modalIn": {
        "opacity": "1",
        "transform": "translateY(0)"
      },
      "modalDialog": {
        "height": "100%",
        "display": "flex",
        "transition": "--search-content-height .2s ease-in-out",
        "flex-direction": "column",
        "--search-content-height": "0px"
      },
      "modalContent": {
        "height": "100%",
        "display": "flex",
        "padding": "10px",
        "flex-direction": "column"
      },
      "modalHeader": {
        "flex": "0 0 auto",
        "display": "flex",
        "padding": "15px",
        "flex-direction": "row"
      },
      "buttonClose": {
        "top": "10px",
        "color": "rgba(0, 0, 0, .6)",
        "right": "10px",
        "width": "50px",
        "border": "2px solid rgba(0, 0, 0, .4)",
        "height": "50px",
        "display": "flex",
        "opacity": "1",
        "z-index": "10",
        "position": "absolute",
        "transition": ".15s ease",
        "align-items": "center",
        "border-radius": "100%",
        "flex-direction": "column",
        "justify-content": "center",
        "background-color": "rgba(255, 255, 255, 0.87)",
        "-webkit-appearance": "none",
        "transition-property": "color, border-color",
        "& .material-icons": {
          "display": "block",
          "font-size": "32px"
        },
        "&:hover": {
          "color": "rgba(0, 0, 0, 1)",
          "border-color": "rgba(0, 0, 0, 1)"
        }
      },
      "modalTitle": {
        "flex": "1 1 auto",
        "color": "#555",
        "width": "auto",
        "border": "0",
        "height": "auto",
        "margin": "0",
        "display": "flex",
        "padding": "0",
        "position": "relative",
        "flex-wrap": "wrap",
        "font-size": "24px",
        "min-height": "40px",
        "text-align": "left",
        "align-items": "center",
        "font-weight": "400",
        "flex-direction": "row",
        "text-transform": "uppercase",
        "vertical-align": "middle",
        "& .material-icons": {
          "color": "#555",
          "width": "38px",
          "border": "0",
          "height": "38px",
          "display": "inline-block",
          "padding": "5px",
          "font-size": "28px",
          "background": "transparent",
          "margin-right": "8px",
          "border-radius": "19.5px"
        }
      },
      "modalBody": {
        "flex": "1 1 auto",
        "width": "auto",
        "border": "0",
        "height": "auto",
        "margin": "0",
        "display": "flex",
        "padding": "0",
        "overflow": "visible",
        "position": "static",
        "margin-top": "25px",
        "flex-direction": "column"
      },
      "container": {
        "flex": "1 1 auto",
        "width": "85%",
        "margin": "0 auto",
        "display": "flex",
        "flex-direction": "column"
      },
      "modalBodyInner": {
        "flex": "1 1 auto",
        "display": "flex",
        "flex-direction": "column"
      },
      "searchBodyContainer": {
        "flex": "1 1 auto",
        "display": "flex",
        "flex-direction": "column"
      },
      "searchControl": {
        "flex": "1 1 auto",
        "display": "flex",
        "align-self": "stretch",
        "flex-direction": "column"
      },
      "searchField": {
        "flex": "0 0 auto",
        "display": "flex",
        "margin-top": "auto",
        "flex-direction": "row"
      },
      "searchInputGroup": {
        "flex": "1 1 auto",
        "color": "rgba(0, 0, 0, 0.87)",
        "width": "100%",
        "border": "1px solid #888",
        "height": "50px",
        "display": "flex",
        "padding": "0",
        "font-size": "14px",
        "background": "#f8f8f8",
        "box-shadow": "inset 0 1px 1px rgba(255, 255, 255, 0.075)",
        "line-height": "1.33",
        "border-radius": "2px",
        "flex-direction": "row"
      },
      "searchFormControl": {
        "flex": "1 1 auto",
        "color": "rgba(0, 0, 0, 0.87)",
        "width": "100%",
        "border": "0",
        "height": "auto",
        "display": "block",
        "padding": "6px 12px",
        "font-size": "20px",
        "background": "rgba(0, 0, 0, 0)",
        "box-shadow": "none",
        "line-height": "1.33",
        "border-width": "1px",
        "border-radius": "0",
        '&::placeholder': {
          "font-style": "italic"
        }
      },
      "searchInputGroupAddon": {
        "width": "0",
        "display": "flex",
        "overflow": "hidden",
        "transition": "width .2s ease"
      },
      "searchInputGroupAddonSecondary": {},
      "searchInputGroupAddonIn": {
        "width": "70px",
        "border-left": "1px solid #888"
      },
      "searchInputGroupAddonButton": {
        "width": "70px"
      },
      "searchResult": {
        "flex": "0 0 0px",
        "height": "0px",
        "opacity": "0",
        "overflow": "hidden",
        "margin-top": "0px",
        "transition": "margin-top .2s ease-in-out, opacity .2s ease-in-out",
        "margin-bottom": "auto"
      },
      "searchResultIn": {
        "flex": "0 0 auto",
        "height": "var(--search-content-height, 0px)",
        "opacity": "1",
        "margin-top": "16px"
      },
      "searchResultBody": {
        "gap": "16px",
        "display": "grid",
        "grid-template-columns": "repeat(auto-fill, minmax(270px, 1fr))"
      }
    }
  },
  SearchModalOverrides: {
    prefix: 'SearchModalOverrides-',
    rules: {
      "modalRoot": {
        "z-index": "1302"
      },
      "button": {
        "width": "1.5em",
        "height": "1.5em",
        "margin-left": "0",
        "background-color": "white"
      },
      "searchInputGroupAddon": {
        "flex-grow": "0",
        "flex-shrink": "0"
      },
      "searchField": {
        "@media (min-width:0px) and (max-width:599.95px)": {
          "margin-top": "0"
        }
      },
      "searchResultBody": {
        "@media (min-width:0px) and (max-width:599.95px)": {
          "grid-template-columns": "repeat(2, 1fr)"
        },
        "@media (min-width:600px) and (max-width:959.95px)": {
          "grid-template-columns": "repeat(3, 1fr)"
        }
      },
      "searchInputGroupAddonIn": {
        "@media (max-width:959.95px)": {
          width: '50px'
        }
      },
      "searchInputGroupAddonButton": {
        "@media (max-width:959.95px)": {
          "width": "50px",
          "min-width": 0
        }
      }
    }
  },
  ResultCard: {
    prefix: 'ResultCard-',
    rules: {
      root: {
        "width": "100%",
        "border": "1px solid transparent",
        "padding": "0",
        "max-width": "560px",
        "align-self": "stretch",
        "border-radius": "4px",
        "flex-direction": "column",
        "text-transform": "none",
        "justify-content": "flex-start",
        "&:before": {
          "top": "-1px",
          "left": "-1px",
          "right": "-1px",
          "border": "1px solid #ccc",
          "bottom": "-1px",
          "content": '""',
          "z-index": "1",
          "position": "absolute",
          "border-radius": "4px"
        },
        '& img, & .CardHeaderDefaultImage-root': {
          "transform": "scale(1)",
          "transition": "transform .15s ease",
          "transform-origin": "50% 50%"
        },
        '&:hover img, &:hover .CardHeaderDefaultImage-root': {
          "transform": "scale(1.1)"
        }
      },
      label: {
        display: 'contents'
      }
    }
  },
  SWSimpleBox: {
    prefix: 'SWSimpleBox-',
    rules: {
      root: {}
    }
  },
  SWButtonContainer: {
    prefix: 'SWButtonContainer-',
    rules: {
      root: {
        '--mobile': 0,
        '@media (max-width:959.95px)': {
          '--mobile': 1
        }
      },
      label: {}
    }
  },
  CardHeader: {
    prefix: "CardHeader-",
    rules: {
      root: {
        "width": "100%",
        "overflow": "hidden",
        "position": "relative",
        "background": "var(--main-image) 50% 50% no-repeat",
        "padding-top": "56.25%",
        "background-size": "cover"
      }
    }
  },
  CardHeaderInner: {
    prefix: "CardHeaderInner-",
    rules: {
      root: {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: 'absolute'
      }
    }
  },
  SwRawImage: {
    prefix: 'SwRawImage-',
    rules: {
      root: {
        width: 'max-content',
        height: 'auto',
        display: 'block',
        'max-width': '100%'
      }
    }
  },
  CardHeaderImage: {
    prefix: 'CardHeaderImage-',
    rules: {
      root: {
        "width": "100%",
        "height": "100%",
        "object-fit": "var(--image-size, cover)",
        "object-position": "50% 50%"
      }
    }
  },
  CardHeaderDefaultImage: {
    prefix: 'CardHeaderDefaultImage-',
    rules: {
      root: {
        "top": "0",
        "left": "0",
        "right": "0",
        "bottom": "0",
        "position": "absolute",
        "background": "var(--default-list-image) no-repeat 50% 50%",
        "background-size": "cover",
        "img + &": {
          "display": "none"
        }
      }
    }
  },
  CardHeaderType: {
    prefix: 'CardHeaderType-',
    rules: {
      root: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        padding: '2px',
        background: 'rgba(0, 0, 0, 0.5)',
        color: '#fff',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        textTransform: 'uppercase',
        // fontWeight: '500',
        zIndex: 3
      }
    }
  },
  CardBody: {
    prefix: "CardBody-",
    rules: {
      root: {
        "flex": "1 1 auto",
        "width": "100%",
        "padding": "16px",
        "border-top": "1px solid #ccc",
        '& h6': {
          fontSize: '20px',
          margin: 0,
          fontWeight: '700'
        },
        '& h6 + p': {
          marginTop: '16px',
          fontSize: '16px'
        }
      }
    }
  },
  CardHeaderDate: {
    prefix: 'CardHeaderDate-',
    rules: {
      root: {
        "top": "calc(50% - 10px)",
        "left": "50%",
        "padding": "12px 24px",
        "z-index": "1",
        "position": "absolute",
        "transform": "translate(-50%, -50%)",
        "border-radius": "4px",
        "background-color": "rgba(255, 255, 255, 1)",
        textAlign: 'center',
        textTransform: 'uppercase',
        '& > div:first-child': {
          fontSize: '32px',
          fontWeight: '700',
          '& + div': {
            fontSize: '16px'
          }
        }
      }
    }
  }
};

try {
  window.CSS.registerProperty({
    name: '--search-content-height',
    inherits: true,
    syntax: '<length>',
    initialValue: '0px'
  });
} catch (e) {
  ;
}
/**
 * @typedef {{
 *   [key: string]: string | StyleBlock
 * }} StyleBlock
 */

/** 
 * @typedef {{
 *   prefix: string,
 *   rules: StyleBlock
 * }} StyleSheet
 */

/**
 * @template {StyleSheet} T
 * @typedef {{
 *   [key in keyof T['rules']]: string
 * }} Classes
 */

/**
 * @template {Record<string, StyleSheet>} T
 * @typedef {{
 *   [key in keyof T]: Classes<T[key]>
 * }} ClassList
 */

/**
 * @template {Record<string, StyleSheet>} T
 * @param {T} rules
 * @return {ClassList<T>}
 */


function mapStyles(rules) {
  /** @type {ClassList<T>} */
  var result = {};
  var sheet = ``;

  for (var key in rules) {
    result[key] = {};

    for (var ruleset in rules[key].rules) {
      result[key][ruleset] = rules[key].prefix + ruleset;
      var flattened = {};
      var media = {};

      function descend(selector, block) {
        if (!flattened[selector]) flattened[selector] = {};

        for (var item in block) {
          if (item.indexOf('&') == -1 && item.indexOf('@') == -1) {
            flattened[selector][item] = block[item];
          } else if (item.indexOf('@') != -1) {
            var _media$item;

            var tmp = flattened;
            flattened = (_media$item = media[item]) !== null && _media$item !== void 0 ? _media$item : {};
            descend(selector, block[item]);
            media[item] = flattened;
            flattened = tmp;
          } else {
            var newSelector = item.replace(/&/g, selector);
            newSelector = newSelector.replace(/\$/g, `.${rules[key].prefix}`);
            descend(newSelector, block[item]);
          }
        }
      }

      descend(`.${rules[key].prefix}${ruleset}`, rules[key].rules[ruleset]);

      for (var node in flattened) {
        sheet += node + "{\n";

        for (var item in flattened[node]) {
          var item0 = item.replace(/([A-Z])/g, (_, ch) => `-${ch.toLowerCase()}`);
          sheet += "\t" + item0 + ": " + flattened[node][item] + ";\n";
        }

        sheet += "}\n\n";
      }

      for (var mq in media) {
        sheet += mq + "{\n";

        for (var node in media[mq]) {
          sheet += `\t${node} {\n`;

          for (var item in media[mq][node]) {
            var item0 = item.replace(/([A-Z])/g, (_, ch) => `-${ch.toLowerCase()}`);
            sheet += `\t\t${item0}: ${media[mq][node][item]};\n`;
          }

          sheet += `\t}\n\n`;
        }

        sheet += '}\n\n';
      }
    }
  }

  var s = document.createElement('div');
  s.innerHTML = `<style type='text/css' data-styles='search-overlay'>${sheet}</style>`;
  document.head.appendChild(s.querySelector('style'));
  return result;
}
/** @type {ClassList<typeof StyleData>} */


var Classes = mapStyles(StyleData);
/**
 * @type {(...args: (null | string | Record<string, any)>) => string}
 */

function clsx(...args) {
  return args.map(v => {
    if (v) {
      if (typeof v == 'string') return v;

      if (typeof v == 'object') {
        return Object.keys(v).filter(key => key && v[key]).join(' ');
      }
    }

    return '';
  }).filter(v => v).join(' ');
}
/** 
 * @typedef {{
*   wrapper: HTMLElement
* }} ModalProps
* @typedef {{
*   title: string,
*   type: string,
*   summary: string,
*   imageUrl: string,
*   linkUrl: string,
*   dateOverlay: string
* }} SearchResult
* @typedef {{
*   in: boolean;
*   query: string;
*   results: null | Array<SearchResult>
* }} ModalState
*/


const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
/** @type {(props: SearchResult) => JSX.Element} */

function SearchCard(props) {
  return /*#__PURE__*/_react.default.createElement("a", {
    className: clsx(Classes.ButtonBase.root, Classes.Button.root, Classes.SWSimpleBox.root, Classes.SWButtonContainer.root, Classes.ResultCard.root, Classes.Button.text),
    tabIndex: 0,
    "aria-disabled": false,
    href: props.linkUrl
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: clsx(Classes.Button.label, Classes.SWButtonContainer.label, Classes.ResultCard.label)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: clsx(Classes.SWSimpleBox.root, Classes.CardHeader.root)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: Classes.CardHeaderInner.root
  }, props.imageUrl && /*#__PURE__*/_react.default.createElement("img", {
    className: clsx(Classes.SwRawImage.root, Classes.CardHeaderImage.root),
    src: props.imageUrl,
    alt: props.title
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: clsx(Classes.SWSimpleBox.root, Classes.CardHeaderDefaultImage.root)
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: clsx(Classes.CardHeaderType.root)
  }, props.type), props.dateOverlay && /*#__PURE__*/_react.default.createElement("div", {
    className: clsx(Classes.SWSimpleBox.root, Classes.CardHeaderDate.root)
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      fontSize: '1.5em',
      fontWeight: 700
    }
  }, new Date(props.dateOverlay).getDate()), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      fontSize: '1em',
      textTransform: 'uppercase'
    }
  }, months[new Date(props.dateOverlay).getMonth()])))), /*#__PURE__*/_react.default.createElement("div", {
    className: Classes.CardBody.root
  }, /*#__PURE__*/_react.default.createElement("h6", null, props.title), props.summary && /*#__PURE__*/_react.default.createElement("p", null, props.summary))));
}
/** @extends {Component<ModalProps, ModalState>} */


class Modal extends _react.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      in: false,
      loading: false,
      query: "",
      results: null
    };
    this.searchResultBody = void 0;
    this.searchResultObserver = void 0;
    this.dialog = void 0;

    this.adjust = () => {
      var _this$searchResultBod, _this$searchResultBod2, _this$dialog;

      var h = (_this$searchResultBod = (_this$searchResultBod2 = this.searchResultBody) === null || _this$searchResultBod2 === void 0 ? void 0 : _this$searchResultBod2.scrollHeight) !== null && _this$searchResultBod !== void 0 ? _this$searchResultBod : 0;
      if (h > 0) h += 160;
      (_this$dialog = this.dialog) === null || _this$dialog === void 0 ? void 0 : _this$dialog.style.setProperty('--search-content-height', `${h}px`);
    };

    this.gotSearchResultBody = tgt => {
      var _this$searchResultObs;

      (_this$searchResultObs = this.searchResultObserver) === null || _this$searchResultObs === void 0 ? void 0 : _this$searchResultObs.disconnect();
      window.removeEventListener('resize', this.adjust);
      this.searchResultBody = tgt;

      if (tgt) {
        this.searchResultObserver = new MutationObserver(this.adjust);
        this.searchResultObserver.observe(tgt, {
          subtree: true,
          childList: true,
          attributes: true,
          characterData: true
        });
        window.addEventListener('resize', this.adjust);
      }
    };

    this.gotDialog = tgt => {
      this.dialog = tgt;
    };

    this.setSearchText = event => this.setState({
      query: event.target.value
    });

    this.resetForm = event => this.setState({
      query: '',
      results: null
    });

    this.close = event => {
      this.setState({
        in: false
      });
    };

    this.doSearch = event => {
      event.preventDefault();
      this.setState({
        loading: true
      });
      fetch(`data/search?q=${encodeURIComponent(this.state.query)}`).then(async result => {
        var data = await result.json();
        this.setState({
          loading: false,
          results: data.items
        });
      });
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        in: true
      });
    }, 16);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.in != this.state.in) {
      if (this.state.in == true) {
        document.body.style.overflow = 'hidden';
      } else if (this.state.in == false) {
        setTimeout(() => {
          document.body.style.overflow = '';

          _reactDom.default.unmountComponentAtNode(this.props.wrapper);
        }, 300);
      }
    }
  }

  componentWillUnmount() {
    setTimeout(() => {
      this.props.wrapper.remove();
    }, 0);
  }

  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: clsx(Classes.SearchModal.modalWrapper, {
        [Classes.SearchModal.modalWrapperIn]: this.state.in
      })
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: clsx(Classes.SearchModal.modalRoot, Classes.SearchModalOverrides.modalRoot, {
        [Classes.SearchModal.modalIn]: this.state.in
      })
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: Classes.SearchModal.modalDialog,
      ref: this.gotDialog
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: Classes.SearchModal.modalHeader
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: Classes.SearchModal.buttonClose,
      type: "button",
      "aria-label": "Close",
      onClick: this.close
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: clsx(Classes.Icon.root, 'material-icons'),
      "aria-hidden": "true"
    }, "close")), /*#__PURE__*/_react.default.createElement("h4", {
      className: Classes.SearchModal.modalTitle
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: clsx(Classes.Icon.root, 'material-icons'),
      "aria-hidden": "true"
    }, "search"), "Search")), /*#__PURE__*/_react.default.createElement("div", {
      className: Classes.SearchModal.modalBody
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: Classes.SearchModal.container
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: Classes.SearchModal.modalBodyInner
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: Classes.SearchModal.searchBodyContainer
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: Classes.SearchModal.searchControl
    }, /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: this.doSearch,
      className: clsx(Classes.SearchModal.searchField, Classes.SearchModalOverrides.searchField),
      onReset: this.resetForm
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: Classes.SearchModal.searchInputGroup
    }, /*#__PURE__*/_react.default.createElement("input", {
      placeholder: "What are you looking for?",
      className: Classes.SearchModal.searchFormControl,
      type: "text",
      value: this.state.query,
      onChange: this.setSearchText
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: clsx(Classes.SearchModal.searchInputGroupAddon, Classes.SearchModalOverrides.searchInputGroupAddon, Classes.SearchModal.searchInputGroupAddonSecondary, {
        [Classes.SearchModal.searchInputGroupAddonIn]: this.state.results != null,
        [Classes.SearchModalOverrides.searchInputGroupAddonIn]: this.state.results != null
      })
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: clsx(Classes.ButtonBase.root, Classes.Button.root, Classes.Button.text, Classes.SearchModal.searchInputGroupAddonButton, Classes.SearchModalOverrides.searchInputGroupAddonButton),
      tabIndex: 0,
      type: "reset"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: Classes.Button.label
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: clsx('material-icons', Classes.Icon.root),
      "aria-hidden": "true"
    }, "clear")))), /*#__PURE__*/_react.default.createElement("div", {
      className: clsx(Classes.SearchModal.searchInputGroupAddon, Classes.SearchModalOverrides.searchInputGroupAddon, {
        [Classes.SearchModal.searchInputGroupAddonIn]: this.state.query != "",
        [Classes.SearchModalOverrides.searchInputGroupAddonIn]: this.state.query != ''
      })
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: clsx(Classes.ButtonBase.root, Classes.Button.root, Classes.Button.text, Classes.SearchModal.searchInputGroupAddonButton, Classes.SearchModalOverrides.searchInputGroupAddonButton),
      tabIndex: 0,
      type: "submit"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: Classes.Button.label
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: clsx('material-icons', Classes.Icon.root),
      "aria-hidden": "true"
    }, "search")))))), /*#__PURE__*/_react.default.createElement("div", {
      className: clsx(Classes.SearchModal.searchResult, {
        [Classes.SearchModal.searchResultIn]: this.state.loading || this.state.results != null
      })
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: Classes.SearchModal.searchResultBody,
      ref: this.gotSearchResultBody
    }, this.state.results == null ? null : this.state.results.map((result, index) => /*#__PURE__*/_react.default.createElement(SearchCard, babelHelpers.extends({
      key: index
    }, result)))))))))))));
  }

}

function showSearch() {
  var c = document.createElement('div');
  document.body.appendChild(c);

  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(Modal, {
    wrapper: c
  }), c);
}